import { action } from "../common/Action"
import { ClientiClient, ClienteData } from "../generated";

const service = new ClientiClient();

export class CustomersFilterData {
    codClienteAzienda?: number;
    filtroNominativo?: string;
    filtroContatto?: string;
    filtroLocalita?: string;
    filtroCaldaia?: string;
    filtroCombustibile?: string;
    filtroPodCatasto?: string;
    viewAnagDismesse?: boolean;
}

class CustomersActions {
    @action
    async add(customer: ClienteData) {
        const id = await service.addCliente(customer);
        return (await service.getCliente(id))!;
    }

    @action
    async update(customer: ClienteData, id: number) {
        await service.updateCliente(customer, id);
        return (await service.getCliente(id))!;
    }
    @action
    async getCliente(id: number) {
        return (await service.getCliente(id))!;
    };

    @action
    getAvailableCodiceClienteAzienda() {
        return service.getAvailableCodiceClienteAzienda();
    };

    @action
    codiceClienteAziendaExist(codice: number, currentIdCliente: number | null) {
        return service.codiceClienteAziendaExist(codice, currentIdCliente);
    };

    @action
    async submitFilter(filter: CustomersFilterData) {
        const result = (await service.getClientiList(filter.codClienteAzienda,
            filter.filtroNominativo,
            filter.filtroContatto,
            filter.filtroLocalita,
            filter.filtroCaldaia,
            filter.filtroCombustibile,
            filter.filtroPodCatasto,
            filter.viewAnagDismesse))!;
        return { filter, result };
    };

    @action
    async delete(customerId: number) {
        const deleteOk = await service.deleteCliente(customerId);
        return { customerId, deleteOk };
    }
}
export default new CustomersActions();